import { apiRequest } from './client';

export function fetchPurchaseShippingReport(token, params = {}) {
  const search = new URLSearchParams();
  if (params.dateMode) search.set('dateMode', params.dateMode);
  if (params.dateFrom) search.set('dateFrom', params.dateFrom);
  if (params.dateTo) search.set('dateTo', params.dateTo);
  if (params.status) search.set('status', params.status);
  if (params.limit) search.set('limit', String(params.limit));
  const qs = search.toString();
  return apiRequest(`/admin/reports/purchase-shipping${qs ? `?${qs}` : ''}`, token);
}

export function fetchBatchReport(token, params = {}) {
  const search = new URLSearchParams();
  if (params.dateMode) search.set('dateMode', params.dateMode);
  if (params.dateFrom) search.set('dateFrom', params.dateFrom);
  if (params.dateTo) search.set('dateTo', params.dateTo);
  if (params.status) search.set('status', params.status);
  if (params.batchCode) search.set('batchCode', params.batchCode);
  if (params.limit) search.set('limit', String(params.limit));
  const qs = search.toString();
  return apiRequest(`/admin/reports/batch${qs ? `?${qs}` : ''}`, token);
}
